
import React from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { CustomTooltip } from "./PieChartDisplay";

interface LineChartDisplayProps {
  data: Array<any>;
  dataKey: string;
  nameKey?: string;
  lineName?: string;
  height?: number | string;
  color?: string;
  margin?: { top: number; right: number; left: number; bottom: number };
}

const LineChartDisplay: React.FC<LineChartDisplayProps> = ({
  data,
  dataKey,
  nameKey = "name",
  lineName = "Aantal",
  height = "100%",
  color = "#0072BC",
  margin = { top: 5, right: 30, left: 20, bottom: 5 }
}) => {
  return (
    <div className="h-80 w-full">
      <ResponsiveContainer width="100%" height={height}>
        <LineChart
          data={data}
          margin={margin}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis 
            dataKey={nameKey} 
            tick={{ fill: '#4B5563', fontSize: 12 }}
            tickLine={{ stroke: '#9CA3AF' }}
            axisLine={{ stroke: '#9CA3AF' }}
            padding={{ left: 10, right: 10 }}
          />
          <YAxis 
            tick={{ fill: '#4B5563', fontSize: 12 }}
            tickLine={{ stroke: '#9CA3AF' }}
            axisLine={{ stroke: '#9CA3AF' }}
          />
          <Tooltip 
            content={<CustomTooltip />} 
            wrapperStyle={{ 
              backgroundColor: 'white', 
              border: '1px solid #ccc', 
              borderRadius: '6px',
              boxShadow: '0px 4px 6px -1px rgba(0, 0, 0, 0.1)' 
            }}
          />
          <Legend 
            wrapperStyle={{ paddingTop: '10px' }}
            iconType="circle"
            iconSize={10}
            formatter={(value) => <span className="text-sm font-medium">{value}</span>}
          />
          <Line 
            type="monotone" 
            dataKey={dataKey} 
            name={lineName} 
            stroke={color} 
            strokeWidth={2}
            dot={{ r: 4, strokeWidth: 2, fill: 'white' }}
            activeDot={{ r: 6, strokeWidth: 0, fill: color }}
            animationDuration={1000}
            animationEasing="ease-out"
            className="filter drop-shadow-sm hover:drop-shadow-md transition-all duration-300"
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default LineChartDisplay;
